(function () {
    
    const EPOCH_MS = 1782384337676;
    const BASE_COUNT = 1_670_312_133;

    // * Counter logic
    function currentCount() {
        const elapsed = Math.max(0, Date.now() - EPOCH_MS);
        return BASE_COUNT + Math.floor(elapsed / 1000);
    }

    function toChars(n) {
        return n.toLocaleString('en-US').split('');
    }

    // * DOM construction 
    // Each digit gets a wrapper span > track span > [face-current span, face-next span].
    // Separators (commas) are plain spans with class nyb-counter__sep.

    function buildSlots(el) {

        el.classList.add('nyb-counter');
        el.innerHTML = '';
        const chars = toChars(currentCount());
        const slots = [];

        chars.forEach((char) => {
            if (char === ',') {
                const sep = document.createElement('span');
                sep.className = 'nyb-counter__sep';
                sep.textContent = ',';
                el.appendChild(sep);
                slots.push(null); // placeholder so indices stay aligned
                return;
            }

            const wrap = document.createElement('span');
            wrap.className = 'nyb-counter__digit';

            const track = document.createElement('span');
            track.className = 'nyb-counter__track';

            // Face shown right now
            const faceCurrent = document.createElement('span');
            faceCurrent.className = 'nyb-counter__face';
            faceCurrent.textContent = char;

            // Face that slides in during the next flip
            const faceNext = document.createElement('span');
            faceNext.className = 'nyb-counter__face';
            faceNext.textContent = char;

            track.appendChild(faceCurrent);
            track.appendChild(faceNext);
            wrap.appendChild(track);
            el.appendChild(wrap);

            slots.push({ track, faceCurrent, faceNext, value: char, flipping: false });
        });

        return slots;
    }

    // * Flip animation
    function flipSlot(slot, newChar) {
        
        if (slot.value === newChar || slot.flipping) {
            return;
        }
        
        slot.flipping = true;

        // Stage the incoming digit in the hidden lower face
        slot.faceNext.textContent = newChar;

        // Start the roll-up
        slot.track.classList.add('nyb-counter__track--flip');
        slot.track.addEventListener('transitionend', function () {
            // Snap back instantly so the transition isn't visible on reset
            slot.track.classList.add('nyb-counter__track--instant');
            slot.track.classList.remove('nyb-counter__track--flip');
            void slot.track.offsetWidth; // force reflow before re-enabling transition
            slot.track.classList.remove('nyb-counter__track--instant');

            // Both faces now show the new digit; next flip will stage the one after
            slot.faceCurrent.textContent = newChar;
            slot.value = newChar;
            slot.flipping = false;

        }, { once: true });
    }

    function updateSlots(slots, count) {
        
        const chars = toChars(count);
        
        if (chars.length !== slots.length) {
            return; // digit-count changed; let tick() rebuild
        }
        
        chars.forEach((char, i) => {
            if (slots[i]) flipSlot(slots[i], char);
        });
    }

    // * Bootstrap 
    function startCounter(el) {

        let slots = buildSlots(el);
        let lastCount = currentCount();

        // Align first tick to the next whole second for a clean cadence
        const msUntilNextTick = 1000 - (Date.now() % 1000);

        setTimeout(function tick() {
            
            const count = currentCount();
            const chars = toChars(count);

            if (chars.length !== slots.length) {
                // Digit count crossed a boundary (e.g. 9,999,999 → 10,000,000); rebuild
                slots = buildSlots(el);
                lastCount = count;
            } 
            else if (count !== lastCount) {
                updateSlots(slots, count);
                lastCount = count;
            }

            setTimeout(tick, 1000);
        }, msUntilNextTick);
    }

    function init() {
        document.querySelectorAll('[data-nyb-counter]').forEach(startCounter);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } 
    else {
        init();
    }
})();
